export const SET_ORDERS = 'SET_ORDERS'
export const SET_ORDERS_META = 'SET_ORDERS_META'
export const SET_RESERVATION = 'SET_RESERVATION'
export const SET_RESERVATIONS = 'SET_RESERVATIONS'
export const SET_RESERVATIONS_META = 'SET_RESERVATIONS_META'
export const SET_RETURNING_ORDERS = 'SET_RETURNING_ORDERS'
export const SET_RETURNING_ORDERS_META = 'SET_RETURNING_ORDERS_META'
export const SET_SUPPLIER_ORDERS = 'SET_SUPPLIER_ORDERS'
export const SET_SUPPLIER_ORDER_PRODUCTS = 'SET_SUPPLIER_ORDER_PRODUCTS'
export const SET_SUPPLIER_ORDERS_META = 'SET_SUPPLIER_ORDERS_META'
export const SET_CARTS = 'SET_CARTS'
export const SET_CARTS_META = 'SET_CARTS_META'
export const SET_ORDER = 'SET_ORDER'
export const ADD_ORDER = 'ADD_ORDER'
export const SET_RETURNING_ORDERS_PRODUCTS = 'SET_RETURNING_ORDERS_PRODUCTS'
export const SET_RETURNING_ORDERS_PRODUCTS_META = 'SET_RETURNING_ORDERS_PRODUCTS_META'
export const EDIT_ORDER = 'EDIT_ORDER'
export const EDIT_RESERVATION = 'EDIT_RESERVATION'
export const SET_ORDER_PRODUCTS = 'SET_ORDER_PRODUCTS'
export const SET_ORDER_PRODUCTS_META = 'SET_ORDER_PRODUCTS_META'
export const SET_RESERVATION_PRODUCTS_BACKUP = 'SET_RESERVATION_PRODUCTS_BACKUP'
export const SET_RESERVATION_PRODUCTS = 'SET_RESERVATION_PRODUCTS'
export const SET_RESERVATION_PRODUCTS_META = 'SET_RESERVATION_PRODUCTS_META'
export const RESET_ORDER_PRODUCTS = 'RESET_ORDER_PRODUCTS'
export const REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT'
export const SET_ORDER_PRODUCTS_BACKUP = 'SET_ORDER_PRODUCTS_BACKUP'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const SET_SUPPLIER_ORDER_SEARCH_FILTERS = 'SET_SUPPLIER_ORDER_SEARCH_FILTERS'
export const SET_LOADING = 'SET_LOADING'
export const UPDATE_RETURN_INFORMATION = 'UPDATE_RETURN_INFORMATION'
export const RESET_RETURN_INFORMATION = 'RESET_RETURN_INFORMATION'
export const SET_DIMENSIONS = 'SET_DIMENSIONS'
export const SET_TRACKING_HISTORY = 'SET_TRACKING_HISTORY'
export const SET_ORDERS_STATISTICS = 'SET_ORDERS_STATISTICS'
export const SET_ORDERS_PRODUCTS_COLUMNS = 'SET_ORDERS_PRODUCTS_COLUMNS'
export const SET_ORDERS_PRODUCTS_ORIGINAL_COLUMNS = 'SET_ORDERS_PRODUCTS_ORIGINAL_COLUMNS'
export const SET_ORDERS_PRODUCTS_SORT_BY = 'SET_ORDERS_PRODUCTS_SORT_BY'
export const SET_RETURNIG_ORDER = 'SET_RETURNIG_ORDER'
export const SET_ORDERS_PRODUCTS_SORT_ORDER = 'SET_ORDERS_PRODUCTS_SORT_ORDER'
export const SET_ORDERS_PRODUCTS_META = 'SET_ORDERS_PRODUCTS_META'
export const SET_ORDERS_PRODUCTS = 'SET_ORDERS_PRODUCTS'

export const SET_RETURING_ORDER_PRODUCTS = 'SET_RETURING_ORDER_PRODUCTS'
export const SET_RETURING_ORDER_PRODUCTS_META = 'SET_RETURING_ORDER_PRODUCTS_META'
export const RESET_RETURING_ORDER_PRODUCTS = 'RESET_RETURING_ORDER_PRODUCTS'
export const REMOVE_RETURNING_ORDER_PRODUCT = 'REMOVE_RETURNING_ORDER_PRODUCT'
export const RESET_RETURNING_ORDER_PRODUCTS = 'RESET_RETURNING_ORDER_PRODUCTS'
export const SET_RETURNING_ORDER_PRODUCTS_META = 'SET_RETURNING_ORDER_PRODUCTS_META'
export const SET_RETURNING_ORDER_PRODUCTS_BACKUP = 'SET_RETURNING_ORDER_PRODUCTS_BACKUP'
export const SET_RETURNING_ORDER_PRODUCTS = 'SET_RETURNING_ORDER_PRODUCTS'
export const EDIT_RETURNING_ORDER = 'EDIT_RETURNING_ORDER'
